
var drawTraceDataTo2D = function (svg, group, trace) {
    var d = svg.createPath();
    d = d.move(trace.points[0].x, trace.points[0].y);
    for (var p = 1; p < trace.points.length; p++) {
        d = d.line(trace.points[p].x, trace.points[p].y);
    }
    return svg.path(group, d, {
    	fill: "none",
    	'stroke-linecap': "round",
    	'stroke-linejoin': "round",
    	strokeWidth: parseFloat(trace.width)
    });
};

module.exports = drawTraceDataTo2D;
